'use strict';

class AutoComplete {
	constructor(props = {}) {
		console.log('AutoComplete::constructor(%o)', props);

		this.options = {
			searchInput: document.querySelector('.js-auto-complete-input'),
			suggestionsContainer: document.querySelector('.js-auto-complete-suggestions'),
			countryInputAppend: document.querySelector('.country-input-append')
		};

		Object.assign(this, props);
		this.countries = s.options._auto_complete_v2_options.countries || [];
		this.regions = [];
		for (let region of this.countries) {
			if (region?.is_region) {
				this.regions[region.english_name] = region;
			}	
		}
		this.style_color_dir = s.options._auto_complete_v2_options.style_color_dir || 'lightblue-green';
		this.language_id = s.options._auto_complete_v2_options.language_id || 1;

		this.pageEvents();
	}

	pageEvents() {
		if (this.options.searchInput && this.countries.length > 0) {
			this.options.suggestionsContainer.style.top = `${this.options.searchInput.offsetHeight + 1}px`;
			this.options.suggestionsContainer.style.width = `${this.options.searchInput.offsetWidth}px`;

			this.options.searchInput.addEventListener('input', async (event) => {
				const search_string = event.target.value.trim().toLowerCase();
				clearTimeout(this.timeout);

				if (search_string.length === 0 
					|| search_string.includes('+') 
					|| !isNaN(search_string)) {
					this.options.suggestionsContainer.innerHTML = '';
					return;
				}

				this.timeout = setTimeout(async () => {
					const suggestions = this.search(search_string);
		
					if (suggestions.length > 0) {
						this.options.suggestionsContainer.innerHTML = suggestions.map((country) => {
							let flag;
							if (country.is_region) {
								flag =`<div><img src="${s.url(`/images/icons/theme/${this.style_color_dir}/maps/${country.code}.png`)}" alt="Region flag" width="40"></div>`;
							} else {
								flag = `<div class="icon-region-flag" data-flag="country-${country.code}"></div>`;
							}

							const country_name =`<div class='country-name'>${country.translated_name}</div>`;
							return this.buildLink(country, flag, country_name);
						}).join('');
					} else {
						this.options.suggestionsContainer.innerHTML = '<span class="px-15 py-10 d-block">' + s.options.messages.TRAVEL_ESIM_COUNTRY_NOT_SUPPORTED + '</span>';
					}
				}, 300);
			});

			this.options.searchInput.addEventListener('keydown', async (event) => {
				const key = event.key;
				if ((key === 'ArrowDown' || key === 'ArrowUp') && this.options.searchInput.value && this.options.suggestionsContainer.innerHTML) {
					let selected = this.options.suggestionsContainer.querySelector('li.selected');
	
					if(!selected) {
						selected = this.options.suggestionsContainer.querySelector('li');
						selected.classList.add('selected');
						this.options.searchInput.value = selected.querySelector('.country-name').innerHTML;
	
					} else {
						let next;
						if (key === 'ArrowDown' && selected.parentElement.nextElementSibling) {
							next = selected.parentElement.nextElementSibling.firstChild;
						}
						if (key === 'ArrowUp' && selected.parentElement.previousElementSibling) {
							next = selected.parentElement.previousElementSibling.firstChild;
						}
						if (next) {
							next.classList.add('selected');
							selected.classList.remove('selected');
							this.options.searchInput.value = next.querySelector('.country-name').innerHTML;
						}
					}
				} else if (key === 'Escape' ) {
					this.options.suggestionsContainer.innerHTML ='';
				} else if (key === 'Enter' || key === 'Tab' ) {
					let selected = this.options.suggestionsContainer.querySelector('li.selected');
					if (selected) {
						selected.parentElement.click();
					} else {
						this.options.suggestionsContainer.querySelectorAll('li .country-name').forEach((element)=> {
							const link = element.parentElement.parentElement;
							if (element.innerHTML.toLowerCase() == this.options.searchInput.value.toLowerCase()
								&& link.tagName.toLowerCase() === 'a' && link.hasAttribute('href')
							) {
								link.click();
							}
						});
					}
				}
			});
		}

		if (this.options.countryInputAppend && this.options.searchInput) {
			this.options.countryInputAppend.addEventListener('click', () => {
				this.options.searchInput.focus();
			});
		}
	}

	search(search_string) {
		let suggestions = [];
		for (let country of this.countries) {
			let translated_name = country.translated_name.toLowerCase();

			if (search_string === translated_name && country?.is_available == '0') {
				return [];
			}

			if (country?.is_available == '0') {
				continue;
			}

			if (search_string === translated_name) {
				const exceptions = this.searchForExceptionsOnMatchFound(search_string, country);
				return this.addRegionsToSuggestions([country].concat(exceptions));
			}

			let distance = this.levenshtein(search_string, translated_name);
			let score = (distance / Math.max(translated_name.length, 1)) * 100;

			if (search_string === translated_name.normalize("NFD").replace(/[\u0300-\u036f]/g, "")) {
				score -= 100;
			}

			if (translated_name.startsWith(search_string)) {
				score -= 30;
			}

			if (translated_name.includes(search_string)) {
				score -= 20;
			}

			if (country.language_id == this.language_id) {
				score -= 50;
			}

			// Fine tuning
			if (search_string.length == 2) {
				if (country.language_id == this.language_id) {
					score -= 30;
				}
				if (translated_name.startsWith(search_string)) {
					score -= 11;
				}
			}

			// Example Search for Korea we want to show only North Korea and South Korea
			if (search_string.length > 2) {
				if (translated_name.startsWith(search_string)) {
					score -= 70;
				}
	
				if (translated_name.includes(search_string)) {
					score -= 70;
				}

				if (country.language_id == this.language_id) {
					score -= 50;
				}
			}

			if (!suggestions[country.english_name] || suggestions[country.english_name].score > score) {
				suggestions[country.english_name] = {... country, score};
			}
		}

		suggestions = Object.values(suggestions).sort((a, b) => a.score - b.score).slice(0, 5);
		suggestions = suggestions.reduce((acc, suggestion, index, arr) => {
			if (index === 0 || suggestion.score - acc[0].score <= 60) {
				acc.push(suggestion);
			} else {
				return acc;
			}
			return acc;
		}, []);

		suggestions.sort((a, b) => {
			const aStarts = a.translated_name.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().startsWith(search_string);
			const bStarts = b.translated_name.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().startsWith(search_string);

			if (aStarts && !bStarts) return -1;
			if (!aStarts && bStarts) return 1;

			return a.translated_name.localeCompare(b.translated_name);
		});

		suggestions = this.addRegionsToSuggestions(suggestions);

		return suggestions[0].score > 20 ? [] : suggestions;
	}

	addRegionsToSuggestions(suggestions) {
		// Add region or global to suggestion if it doesn't already exist.
		// Example search for Singapore will show Asia and Global.
		if (suggestions.length > 0 && (suggestions.length + (suggestions[0]?.regions?.length) < 6)) {
			for (let i = 0; i < suggestions[0].regions.length; i++) {
				let region = suggestions[0].regions[i];
				if (this.regions[region] && !suggestions.find(s => s.translated_name === region)) {
					suggestions.push(this.regions[region]);
				}
			}
		}
		return suggestions;
	}
	
	levenshtein(a, b) {
		if (a.length === 0)
			return b.length;
		if (b.length === 0)
			return a.length;
		const matrix = [];
		let i;
		for (i = 0; i <= b.length; i++) {
			matrix[i] = [i];
		}
		let j;
		for (j = 0; j <= a.length; j++) {
			matrix[0][j] = j;
		}
		for (i = 1; i <= b.length; i++) {
			for (j = 1; j <= a.length; j++) {
				if (b.charAt(i - 1) === a.charAt(j - 1)) {
					matrix[i][j] = matrix[i - 1][j - 1];
				}
				else {
					matrix[i][j] = Math.min(matrix[i - 1][j - 1] + 1, Math.min(matrix[i][j - 1] + 1, matrix[i - 1][j] + 1));
				}
			}
		}
		return matrix[b.length][a.length];
	}

	buildLink(country, flag, country_name) {
		const form = this.options.searchInput.closest('form');
		let link;
		if (this.options.searchInput.dataset.suggestLink) {
			link = s.url(this.options.searchInput.dataset.suggestLink + country.english_name);
		} else if (form && form.action){
			link = form.action + '/' + country.english_name;
		} else {
			link = s.url('international-calls/' + country.english_name);
		}
		return `<a href="${link}"><li>${flag} ${country_name}</li></a>`;
	}

	searchForExceptionsOnMatchFound(search_string, selected_country) {
		let result = [];

		for (let country of this.countries) {
			let translated_name = country.translated_name.toLowerCase();

			if (search_string === translated_name) {
				continue;
			}

			if (translated_name.includes(search_string) 
				&& country.language_id == selected_country.language_id 
				&& search_string.length > 3
				&& selected_country.code !== country.code
			) {
				result.push(country);
			}
		}
		return result;
	}
}

window.addEventListener('DOMContentLoaded', () => {
	try {
		new AutoComplete();
	} catch (error) {
		console.error(error);
	}
});
